import { api } from './client';
import type { Envelope } from './types';

export interface ScheduleItem {
  id: string;
  meetingId: string;
  title: string;
  startAt: string;
  endAt: string | null;
  placeCandidateId: string | null;
  orderIndex: number | null;
  memo: string | null;
  createdByUserId: string;
  createdAt: string;
}

export interface ScheduleComment {
  id: string;
  scheduleItemId: string;
  userId: string;
  nickname: string;
  content: string;
  createdAt: string;
}

export async function listScheduleItems(meetingId: string) {
  const { data } = await api.get<Envelope<ScheduleItem[]>>(
    `/meetings/${meetingId}/schedule-items`,
  );
  return data.data;
}

export interface ScheduleItemInput {
  title: string;
  startAt: string;
  endAt?: string;
  placeCandidateId?: string;
  orderIndex?: number;
  memo?: string;
}

export async function createScheduleItem(meetingId: string, input: ScheduleItemInput) {
  const { data } = await api.post<Envelope<ScheduleItem>>(
    `/meetings/${meetingId}/schedule-items`,
    input,
  );
  return data.data;
}

export async function updateScheduleItem(id: string, input: Partial<ScheduleItemInput>) {
  const { data } = await api.patch<Envelope<ScheduleItem>>(
    `/schedule-items/${id}`,
    input,
  );
  return data.data;
}

export async function deleteScheduleItem(id: string) {
  await api.delete(`/schedule-items/${id}`);
}

export async function listScheduleComments(scheduleItemId: string) {
  const { data } = await api.get<Envelope<ScheduleComment[]>>(
    `/schedule-items/${scheduleItemId}/comments`,
  );
  return data.data;
}

export async function addScheduleComment(scheduleItemId: string, content: string) {
  const { data } = await api.post<Envelope<ScheduleComment>>(
    `/schedule-items/${scheduleItemId}/comments`,
    { content },
  );
  return data.data;
}

export async function deleteScheduleComment(commentId: string) {
  await api.delete(`/schedule-comments/${commentId}`);
}
